import * as React from 'react';

function IconActionLogoutSmall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M4.14098 7.25665L5.82245 5.57518L5.03216 4.78489L1.99991 7.81714L5.03216 10.8494L5.82245 10.0591L4.14098 8.37763H7.27412V7.25665H4.14098ZM7.27412 2.77274V7.25665H10.6371V8.37763H7.27412V12.8615H14V2.77274H7.27412Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconActionLogoutSmall;
